var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup9214(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.444,
    height: 27.667,
    viewBox: "0 0 18.444 27.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9214",
    "data-name": "Group 9214",
    transform: "translate(-83 -1169)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "transferencia-de-dinero",
    transform: "translate(79 1169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58566",
    "data-name": "Path 58566",
    d: "M21.868,20.153H4.576a.576.576,0,0,1,0-1.153H21.868a.576.576,0,1,1,0,1.153Z",
    transform: "translate(0 2.903)",
    fill: "#0058f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58567",
    "data-name": "Path 58567",
    d: "M19.562,27.667H6.882A2.886,2.886,0,0,1,4,24.785V2.882A2.886,2.886,0,0,1,6.882,0H19.562a2.886,2.886,0,0,1,2.882,2.882v21.9A2.886,2.886,0,0,1,19.562,27.667ZM6.882,1.153A1.731,1.731,0,0,0,5.153,2.882v21.9a1.731,1.731,0,0,0,1.729,1.729H19.562a1.731,1.731,0,0,0,1.729-1.729V2.882a1.731,1.731,0,0,0-1.729-1.729Z",
    fill: "#0058f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58568",
    "data-name": "Path 58568",
    d: "M12.738,14.417H10.576a.576.576,0,0,1,0-1.153h2.161a.8.8,0,0,0,.72-.865.8.8,0,0,0-.72-.865h-.865A1.952,1.952,0,0,1,10,9.517,1.952,1.952,0,0,1,11.873,7.5h2.161a.576.576,0,1,1,0,1.153H11.873a.8.8,0,0,0-.72.865.8.8,0,0,0,.72.865h.865A1.952,1.952,0,0,1,14.611,12.4,1.952,1.952,0,0,1,12.738,14.417Z",
    transform: "translate(0.917 1.146)",
    fill: "#0058f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58569",
    "data-name": "Path 58569",
    d: "M12.076,15.344a.577.577,0,0,1-.576-.576V13.326a.576.576,0,0,1,1.153,0v1.441A.577.577,0,0,1,12.076,15.344Z",
    transform: "translate(1.146 1.948)",
    fill: "#0058f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58570",
    "data-name": "Path 58570",
    d: "M12.076,8.882a.577.577,0,0,1-.576-.576V6.576a.576.576,0,1,1,1.153,0V8.306A.577.577,0,0,1,12.076,8.882Z",
    transform: "translate(1.146 0.917)",
    fill: "#0058f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    transform: "translate(91 1193)",
    fill: "#0058f4",
    stroke: "#0058f4",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 0.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup9214);
export default __webpack_public_path__ + "static/media/Group 9214.6c03c261221c2ab0429b167e0c31fd76.svg";
export { ForwardRef as ReactComponent };